import React from 'react';

export const DinosaurFrontPage = ({ theme: propTheme, isActiveWomensMode }) => {
    const [theme, setTheme] = React.useState(propTheme);

    React.useEffect(() => {
        if (propTheme) {
            setTheme(propTheme);
        } else {
            fetchActiveTheme();
        }
    }, [propTheme]);

    const fetchActiveTheme = async () => {
        try {
            const configRes = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/GetConfig/1`);
            const configData = await configRes.json();
            if (configData.success && configData.data?.themeId) {
                const response = await fetch(`${process.env.REACT_APP_API_URL}Dinosaur/GetTheme/${configData.data.themeId}`);
                const data = await response.json();
                if (data.success) {
                    setTheme(data.data);
                }
            }
        } catch (e) {
            console.error("Error al obtener tema inicial en portada:", e);
        }
    };

    const getMediaUrl = (path) => {
        if (!path) return '';
        if (path.startsWith('http://') || path.startsWith('https://')) return path;
        const apiBase = (process.env.REACT_APP_API_URL || '').replace('/api/', '/').replace('/api', '/');
        return `${apiBase}${path}`;
    };

    if (!theme) {
        return (
            <div className="d-flex justify-content-center align-items-center w-100 h-100 bg-dark text-white" style={{ height: '100vh', width: '100vw' }}>
                <div>
                    {/* <h3>DINOSAURIO</h3> */}
                    <p className="text-muted">Esperando la selección de un tema en el panel de administración...</p>
                </div>
            </div>
        );
    }

    const coverTitleColor = theme.coverTitleColor || theme.CoverTitleColor || '#ffffff';
    const titleColor = coverTitleColor;
    const subtitleColor = theme.borderColors || theme.BorderColors || '#888899';
    const coverBgUrl = theme.coverBackgroundUrl || theme.CoverBackgroundUrl;
    const coverBgType = theme.coverBackgroundType || theme.CoverBackgroundType;
    const coverTitle = theme.coverTitle || theme.CoverTitle;
    const sponsorLogoUrl = theme.sponsorLogoUrl || theme.SponsorLogoUrl;
    const coverBgColor = theme.coverBackgroundColor || theme.CoverBackgroundColor;

    const hasBgImage = !!coverBgUrl;
    const hasBgVideo = coverBgType === 'video' && coverBgUrl;

    const introStyles = `
        .dino-intro {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
            width: 100vw;
            color: #fff;
            text-align: center;
            overflow: hidden;
            position: relative;
        }
        .dino-intro__logo {
            max-width: 400px;
            margin-bottom: 2rem;
            animation: pulse-logo-dino 3s infinite alternate;
        }
        .dino-intro__title {
            font-size: 5.5rem;
            font-weight: 900;
            text-transform: uppercase;
            letter-spacing: 4px;
            margin: 0;
            animation: glow-title-dino 1.5s ease-in-out infinite alternate;
            font-family: 'Outfit', 'Inter', sans-serif;
        }
        @keyframes pulse-logo-dino {
            0% { transform: scale(0.98); }
            100% { transform: scale(1.02); }
        }
        @keyframes glow-title-dino {
            0% { text-shadow: 0 0 30px rgba(255, 255, 255, 0.2); }
            100% { text-shadow: 0 0 45px rgba(255, 255, 255, 0.4); }
        }
    `;

    return (
        <div className="dino-intro" style={{
            backgroundColor: coverBgType === 'color' ? coverBgColor : '#0e0e1a',
            backgroundImage: hasBgImage ? `url(${getMediaUrl(coverBgUrl)})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
            <style>{introStyles}</style>

            {hasBgVideo && (
                <video 
                    autoPlay 
                    loop 
                    muted 
                    playsInline 
                    className="position-absolute w-100 h-100 object-fit-cover"
                    style={{ top: 0, left: 0, zIndex: 1 }}
                >
                    <source src={getMediaUrl(coverBgUrl)} type="video/mp4" />
                </video>
            )}

            <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100 w-100" style={{ zIndex: 10 }}>
                {/* Logo del patrocinador en portada */}
                {sponsorLogoUrl ? (
                    <img 
                        src={getMediaUrl(sponsorLogoUrl)} 
                        alt="Sponsor Logo" 
                        className="dino-intro__logo" 
                        style={{ maxHeight: '180px', objectFit: 'contain', width: '400px' }}
                    />
                ) : (
                    <img src="/img/page/adsl-five.png" className="dino-intro__logo" alt="ADSL Logo" />
                )}

                <p className="text-uppercase fw-bold fs-1" style={{ color: titleColor, letterSpacing: '3px' }}>Presenta</p>
                
                {/* Título de la dinámica dinámico desde el formulario */}
                <h1 className="dino-intro__title" style={{ color: titleColor }}>
                    {coverTitle || 'DINOSAURIO'}
                </h1>

                {/* Pie de créditos corporativo ajustado con estilos consistentes */}
                <p className='text-center FooterCredits text-white py-3 mb-0 fw-bold' style={{ position: 'fixed', bottom: '15px', left: '50%', transform: 'translateX(-50%)', opacity: 0.9, fontSize: '22px', fontFamily: 'sans-serif', zIndex: 12, letterSpacing: '1px', textShadow: '2px 2px 4px rgba(0,0,0,0.6)' }}>
                    Hecho con ♥ por Interaktia
                </p>
            </div>
        </div>
    );
};
